import { useTranslation } from 'react-i18next'

import { useContractNewProducts } from '@/Contract/ui/context'
import { productContractingTranslation } from '@/Contract/ui/contractTranslation'
import { LogaltySuccess } from '@/Logalty/ui/molecules'
import { navigationRoutes } from '@/Shared/ui/routers'
import { useUserData } from '@/User/ui/context'
import { useNavigate } from 'react-router-dom'

export const ContractNewProductsStep5SuccessScreen = (): JSX.Element => {
  const { t } = useTranslation()
  const { getUserData } = useUserData()
  const navigation = useNavigate()

  const {
    logalty: { signStatus },
  } = useContractNewProducts()

  const handleReturn = (): void => {
    getUserData().then(() => {
       navigation(navigationRoutes.contractsProductsData, { state: { selectedTab: 1 } })
    })
  }

  return (
    <LogaltySuccess
      title={t(
        productContractingTranslation.contractProductPage.confirmationScreen.success
          .title,
      )}
      description={t(
        productContractingTranslation.contractProductPage.confirmationScreen.success
          .description,
      )}
      buttonLabel={t(
        productContractingTranslation.contractProductPage.confirmationScreen.success
          .button.label,
      )}
      signStatus={signStatus}
      returnCallback={handleReturn}
    />
  )
}
